import * as gregorian from 'cldr-data/main/es/ca-gregorian.json';
import * as numberingSystems from 'cldr-data/supplemental/numberingSystems.json';
import * as numbers from 'cldr-data/main/es/numbers.json';
import * as timeZoneNames from 'cldr-data/main/es/timeZoneNames.json';

import { L10n, loadCldr, setCulture } from '@syncfusion/ej2-base';

import { AppComponent } from 'app/app.component';
import { appConfig } from 'app/app.config';
import { bootstrapApplication } from '@angular/platform-browser';
import { registerLicense } from '@syncfusion/ej2-base';

// Registering Syncfusion license key
registerLicense('Ngo9BigBOggjHTQxAR8/V1NNaF5cXmBCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdmWXteeHVQRGNYWUx0W0ZWYUA=');

bootstrapApplication(AppComponent, appConfig).catch((err) =>
    console.error(err)
);


loadCldr(numberingSystems, gregorian, numbers, timeZoneNames);

// 🌐 Establecer cultura e idioma
setCulture('es');

L10n.load({
    'es': {
        'schedule': {
            'day': 'Día',
            'week': 'Semana',
            'workWeek': 'Semana laboral',
            'month': 'Mes',
            'agenda': 'Agenda',
            'today': 'Hoy',
            'noEvents': 'No hay citas',
            'allDay': 'Todo el día',
            'date': 'Fecha',
            'event': 'Evento',
            'time': 'Hora',
            'newEvent': 'Nueva cita',
            'saveButton': 'Guardar',
            'cancelButton': 'Cancelar',
            'deleteButton': 'Eliminar',
            'editEvent': 'Editar cita',
            'deleteEvent': 'Eliminar cita',
            'editRecurringEvent': 'Editar evento repetitivo',
            'deleteRecurringEvent': 'Eliminar evento repetitivo',
            'deleteContent': '¿Está seguro(a) de que desea eliminar esta cita?'
        },
        'calendar': {
            'today': 'Hoy'
        }
    }
});